
import type { ActiveSessionsType, GroupingTableType, Loadings, SearchMNNType, SelectedMNNType, TemplateType } from '../types';
import { searchStateStore, SearchStateStore } from './searchState';
import { SearchTableBodyType } from '@/features/SearchControl/hooks/useSearchTable/types';
import { WebSocketSearchSourcesType } from '@/shared/service/wsSearch/types';

class SearchSync {
  state: SearchStateStore;

  constructor(storeState: SearchStateStore) {
    this.state = storeState;
  }
  //Гетеры
  //______________________________________________________________________________________________
  public getLoadings() {
    return this.state.loadings;
  }
  
  public getSearchData() {
    return this.state.searchData;
  }

  public getSearchMNN() {
    return this.state.searchMNN;
  }

  public getSelectedMNN() {
    return this.state.selectedMNN;
  }

  public getAutoMNN() {
    return this.state.autoMNN;
  }

  public getActiveSessions() {
    return this.state.activeSessions;
  }
  //______________________________________________________________________________________________



  //Сетеры
  //______________________________________________________________________________________________
  public setLoadings(value: boolean, key: keyof Loadings) {
    this.state.loadings = { ...this.state.loadings, [key]: value };
  }

  public setErrorSearch(value: boolean) {
    this.state.errorSearch = value;
  }

  public setSearchMNN(value: SearchMNNType[]) {
    this.state.searchMNN = [...value];
  }

  public setSearchAutoMNN(value: string[]) {
    this.state.autoMNN = [...value];
  }

  public setFilterCount(value: number) {
    this.state.filterCount = value;
  }

  public setSearchData(value: SearchTableBodyType[]) {
    this.state.searchData = [...value];
  }

  public setBasketData(value: SearchTableBodyType[]) {
    this.state.basketData = [...value];
  }

  public setActiveSessions(value: ActiveSessionsType[]) {
    this.state.activeSessions = [...value];
  }

  public setSelectedMNN(value: SelectedMNNType) {
    this.state.selectedMNN = value;
  }

  public setSearchStatus(value: WebSocketSearchSourcesType) {
    this.state.searchStatus = value;
  }

  public setSelectedMnn(value: number[]) {
    this.state.selectedMnnInTable = [...value];
  }

  public setWebSocketSession(value: number) {
    this.state.webSocketSessions = value;
  }

  public setSelectedMnnBasket(value: number[]) {
    this.state.selectedMnnInTableBasket = [...value];
  }

  public setFavoritesMnn(value: number[]) {
    this.state.favoritesMnnInTable = [...value];
  }

  public setQuestions(value: Record<number, boolean>) {
    this.state.questionsMnnInTable = { ...value };
  }

  public setTemplates(value: TemplateType[]) {
    this.state.templates = [...value];
  }

  public setSelectedSynonyms(value: Record<string, string[]>) {
    this.state.selectedSynonyms = { ...value };
  }

  public setSelectedSynonymsRefresh(value: Record<string, string[]>) {
    this.state.selectedSynonymsRefresh = { ...value };
  }

  public setActiveSession(value: number) {
    this.state.activeSession = value;
  }

  public setActiveSearchSession(value: number) {
    this.state.activeSearchSessions = value;
  }

  public setClearAllMNN() {
    this.state.selectedMNN = {} as SelectedMNNType;
    this.state.searchMNN = [];
    this.state.searchData = [];
    this.state.selectedMnnInTable = [];
    this.state.favoritesMnnInTable = [];
    this.state.questionsMnnInTable = {};
    this.state.selectedSynonymsRefresh = {};
    this.state.searchStatus = {} as WebSocketSearchSourcesType;
  }

  public clearSearchStatus(){
    this.state.searchStatus = {} as WebSocketSearchSourcesType;
  }

  public setNeedUpdate(value: {
    isNeed: boolean;
    id: number;
    type: string;
  } | null){
    this.state.needUpdated = value;
  }

  public setStartUpdate(value: boolean) {
    this.state.isStartUpdate = value;
  }


  public setGroupingTable(value: GroupingTableType[]) {
    this.state.groupingTable = [...value];
  }

  public setFiltersTable(value: string[]) {
    this.state.filters = [...value];
  }
  //______________________________________________________________________________________________
}

export const searchSyncStore = new SearchSync(searchStateStore);
export type SearchSyncStore = typeof searchSyncStore;
